import { Link } from 'react-router-dom';
import React from 'react';

function Gestaltungsprinzipien() {
    return (

        <div
            className="bg-Gestaltungsprinzipien-wrapper view"
            style={{
                backgroundImage: `url(${process.env.PUBLIC_URL + '/img/bg-green.svg'})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom left',
                minHeight: '100vh',
                width: '100%',
            }}
        >
            <main className="container" role="main">

                <Link to="/" className="back-btn">← Zurück</Link>
                <h1 className="section-title">Rhythmus</h1>
           


            
                    <div className="grid">


                        <Link to="/gestaltungsprinzipienlernfeld1" className="maincard card1" aria-label="GestaltungsprinzipienLernfeld1">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-gestaltungsprinzipien.png'} alt="GestaltungsprinzipienLernfeld1" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">Lange und kurze Schläge</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>

                        <Link to="/gestaltungsprinzipienlernfeld2" className="maincard card2" aria-label="GestaltungsprinzipienLernfeld2">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-gestaltungsprinzipien.png'} alt="GestaltungsprinzipienLernfeld2" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">GestaltungsprinzipienLernfeld2</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>


                        <Link to="/gestaltungsprinzipienlernfeld3" className="maincard card3" aria-label="GestaltungsprinzipienLernfeld3">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-gestaltungsprinzipien.png'} alt="GestaltungsprinzipienLernfeld3" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">GestaltungsprinzipienLernfeld3</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>

                        <Link to="/gestaltungsprinzipienlernfeld4" className="maincard card4" aria-label="GestaltungsprinzipienLernfeld4">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-gestaltungsprinzipien.png'} alt="" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">GestaltungsprinzipienLernfeld4</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>


                        <Link to="/gestaltungsprinzipienlernfeld5" className="maincard card5" aria-label="GestaltungsprinzipienLernfeld5">
                            <div className="card__header">
                                <img src={process.env.PUBLIC_URL + '/img/icon-gestaltungsprinzipien.png'} alt="" />
                            </div>
                            <div className="card__body">
                                <h2 className="card__title">GestaltungsprinzipienLernfeld5</h2>
                                <p className="card__desc">Verbessere deine sprachlichen und schriftlichen Fähigkeiten.</p>
                            </div>
                        </Link>
                    </div>
                     </main>
                </div>
         

    );
}

export default Gestaltungsprinzipien;